import React, { Component } from "react"
import { SelectCustom } from "../../components"
import {
  RelatorioDeclaracaoDoPrepostoForm,
  RelatorioAtestadoDeCapacidadeTecnicaForm,
  RelatorioDeAtividadesRealizadasForm,
  RelatorioAtestoDeServicoForm,
  RelatorioTermoDeApostilamentoForm
} from "./index"

export default class RelatoriosForm extends Component {
  constructor() {
    super()
    this.onChangeTipo = this.onChangeTipo.bind(this)
    this.enableForm = this.enableForm.bind(this)
    this.state = {
      tipo: "",
      showAtestadoDeCapacidadeTecnica: false,
      showDeclaracaoDoPreposto: false,
      showReciboDeAtesto: false,
      showAtividadesRealizadas: false,
      showTermoDeApostilamento: false
    }
  }
  enableForm(value) {
    var newState = {
      showAtestadoDeCapacidadeTecnica: value === "0",
      showDeclaracaoDoPreposto: value === "1",
      showReciboDeAtesto: value === "2",
      showAtividadesRealizadas: value === "3",
      showTermoDeApostilamento: value === "4"
    }
    this.setState(newState)
  }
  onChangeTipo(event) {
    var newValue = event.target.value
    this.enableForm(newValue)
    this.setState({
      tipo: newValue
    })
  }
  render() {
    return (
      <div className="container-fluid">
        <div>
          <div className="card card-plain">
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">Documentos</h4>
              <p className="category" />
            </div>
            <div className="card-content">
              <div className="row">
                <SelectCustom
                  sizeClass="col-md-3"
                  options={this.props.tipos}
                  label="Documento a ser emitido"
                  onChange={this.onChangeTipo}
                  value={this.state.tipo}
                />
              </div>
              <div className="row">
                <div className="col-md-9">
                  {this.state.showAtestadoDeCapacidadeTecnica && (
                    <RelatorioAtestadoDeCapacidadeTecnicaForm />
                  )}
                  {this.state.showDeclaracaoDoPreposto && (
                    <RelatorioDeclaracaoDoPrepostoForm />
                  )}
                  {this.state.showReciboDeAtesto && (
                    <RelatorioAtestoDeServicoForm />
                  )}
                  {this.state.showAtividadesRealizadas && (
                    <RelatorioDeAtividadesRealizadasForm />
                  )}
                  {this.state.showTermoDeApostilamento && (
                    <RelatorioTermoDeApostilamentoForm />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/documentos/RelatoriosForm.js